import { render } from "./ButtonLoader.vue?vue&type=template&id=640b2eb8"
import script from "./ButtonLoader.vue?vue&type=script&lang=js"
export * from "./ButtonLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__